import { render, staticRenderFns } from "./MdtRoomSearch.vue?vue&type=template&id=60caf12c&scoped=true"
import script from "./MdtRoomSearch.vue?vue&type=script&lang=js"
export * from "./MdtRoomSearch.vue?vue&type=script&lang=js"
import style0 from "./MdtRoomSearch.vue?vue&type=style&index=0&id=60caf12c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60caf12c",
  null
  
)

export default component.exports